import { render, staticRenderFns } from "./RevenueDataLog.vue?vue&type=template&id=185d04d4&scoped=true"
import script from "./RevenueDataLog.vue?vue&type=script&lang=js"
export * from "./RevenueDataLog.vue?vue&type=script&lang=js"
import style0 from "./RevenueDataLog.vue?vue&type=style&index=0&id=185d04d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185d04d4",
  null
  
)

export default component.exports